import React from 'react'

export default function Home() {
  return (
    <div>
      <h2>Welcome to B2B Punchout Home Page</h2>
    </div>
  )
}
